/**
 * Categories service
 * Manages asset categories
 */

import { supabase } from '@/lib/supabase'

export interface AssetCategory {
  id: string
  name: string
  created_at: string
}

/**
 * Get all asset categories
 */
export async function getAllCategories(): Promise<AssetCategory[]> {
  try {
    const { data, error } = await supabase
      .from('asset_categories')
      .select('*')
      .order('name', { ascending: true })

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching categories:', error)
    throw error
  }
}

/**
 * Get a category by id
 */
export async function getCategoryById(id: string): Promise<AssetCategory | null> {
  try {
    const { data, error } = await supabase
      .from('asset_categories')
      .select('*')
      .eq('id', id)
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error fetching category:', error)
    throw error
  }
}

/**
 * Create a new category
 */
export async function createCategory(name: string): Promise<AssetCategory> {
  try {
    const { data, error } = await supabase
      .from('asset_categories')
      .insert({ name })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error creating category:', error)
    throw error
  }
}

/**
 * Update a category
 */
export async function updateCategory(id: string, name: string): Promise<AssetCategory> {
  try {
    const { data, error } = await supabase
      .from('asset_categories')
      .update({ name })
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error updating category:', error)
    throw error
  }
}

/**
 * Delete a category
 */
export async function deleteCategory(id: string): Promise<void> {
  try {
    const { error } = await supabase
      .from('asset_categories')
      .delete()
      .eq('id', id)

    if (error) throw error
  } catch (error) {
    console.error('Error deleting category:', error)
    throw error
  }
}
